import { FREE_EMAIL_DOMAINS } from './constants'
import { createLocalMarker } from './local-marker'

export const PREFERRED_USERNAME_PENDING_KEY = 'preferred-username-pending'

const freeEmailDomains = new Set(FREE_EMAIL_DOMAINS.map((domain) => String(domain).toLowerCase().trim()))
const EMAIL_PATTERN = /^[^@\s]+@[^@\s]+\.[^@\s]+$/

export const isBusinessEmailAddress = (email) => {
  const normalized = typeof email === 'string' ? email.trim().toLowerCase() : ''
  if (!EMAIL_PATTERN.test(normalized)) return false

  const domain = normalized.split('@').pop().replace(/\.+$/, '')
  if (!domain.includes('.')) return false

  const root = domain.split('.').slice(-2).join('.')
  return !freeEmailDomains.has(domain) && !freeEmailDomains.has(root)
}

const marker = createLocalMarker({
  key: PREFERRED_USERNAME_PENDING_KEY,
  maxAttempts: 3,
  maxAgeMs: 7 * 24 * 60 * 60 * 1000,
  isValid: ({ email }) => isBusinessEmailAddress(email)
})

export const readPreferredUsernamePending = marker.read
export const storePreferredUsernamePending = marker.store
export const clearPreferredUsernamePending = marker.clear
